import React, { useState, useEffect, useRef } from 'react';
import './index.sass';

const PopupLayout = React.forwardRef(({
  children,
  onClose,
  closeHidden = true,
  maskVisible = true,
  outSideClickable = false,
  handleOutsideClick = true,
  animation = 'fade',
  zIndex = 99999,
}, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const contentRef = useRef(null);

  React.useImperativeHandle(ref, () => ({
    open: () => defaultOpen(),
    close: () => defaultClose()
  }));

  const defaultOpen = () => {
    setIsVisible(true);
    setIsAnimating(true);
  };

  const defaultClose = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
    }, 500);
  };

  const handlePopupClose = () => {
    if (handleOutsideClick) {
      onClose ? onClose() : defaultClose();
    }
  }

  useEffect(() => {
    if (isVisible && contentRef.current) {
      contentRef.current.getBoundingClientRect();
    }
  }, [isVisible]);

  if (!isVisible && closeHidden) return null;

  const animationClass = isAnimating ? ` ${animation} enter` : ` ${animation} exit`;
  const maskClass = maskVisible ? '' : ' mask-invisible';
  const clickableClass = outSideClickable ? ' clickable' : '';
  const overlayClass = closeHidden ? ' overlay-hidden' : '';

  return (
    <div
      style={{ zIndex: zIndex }}
      className={`popup-overlay${overlayClass}${animationClass}${maskClass}${clickableClass}`}
      onClick={handlePopupClose}
    >
      <div 
        ref={contentRef}
        className={`popup-content${animationClass}`}
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
});

export { PopupLayout }; 